export default "__VITE_ASSET__58c2252e__"